<template>
  <Patch>
    <h5 slot="title">系統設定</h5>

  </Patch>
</template>

<script>
import Patch from '../common/AdminPatch';

export default {
  name: 'ADCManagement',
  components: {
    Patch,
  },
};
</script>



// WEBPACK FOOTER //
// SystemSettings.vue?42fad0fa